<template>
  <b-card>
    <b-card-title class="d-flex justify-content-between">
      <div>Genel Bilgi</div>
      <div>
        <b-form-checkbox
          :checked="detailForm"
          name="check-button"
          switch
          inline
          @change="detailToggle"
        >
          Detaylı Bilgi
        </b-form-checkbox>
      </div>
    </b-card-title>
    <b-row>
      <b-col cols="12">
        <supplier-type />
      </b-col>
      <b-col cols="12">
        <company />
      </b-col>
      <b-col
        cols="12"
        md="12"
      >
        <phone />
      </b-col>
      <b-col cols="12">
        <phone-alert />
      </b-col>
      <b-col
        v-if="detailForm"
        cols="12"
        md="6"
      >
        <phone2 />
      </b-col>
      <b-col
        v-if="detailForm"
        cols="12"
        md="6"
      >
        <fax />
      </b-col>
      <b-col cols="12">
        <email />
      </b-col>
      <b-col
        cols="12"
        md="12"
      >
        <meet />
      </b-col>
      <b-col
        v-if="detailForm"
        cols="12"
      >
        <notes />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BRow, BCol, BCard, BCardTitle, BFormCheckbox,
} from 'bootstrap-vue'
import SupplierType from '@/views/Admin/Suppliers/elements/SupplierType.vue'
import Company from '@/views/Admin/Suppliers/elements/Company.vue'
import Phone from '@/views/Admin/Suppliers/elements/Phone.vue'
import PhoneAlert from '@/views/Admin/Suppliers/elements/PhoneAlert.vue'
import Phone2 from '@/views/Admin/Suppliers/elements/Phone2.vue'
import Fax from '@/views/Admin/Suppliers/elements/Fax.vue'
import Email from '@/views/Admin/Suppliers/elements/Email.vue'
import Meet from '@/views/Admin/Suppliers/elements/Meet.vue'
import Notes from '@/views/Admin/Suppliers/elements/Notes.vue'

export default {
  name: 'SupplierForm',
  components: {
    BRow,
    BCol,
    BCard,
    BCardTitle,
    BFormCheckbox,
    SupplierType,
    Company,
    Phone,
    PhoneAlert,
    Phone2,
    Fax,
    Email,
    Meet,
    Notes,
  },
  computed: {
    detailForm() {
      return this.$store.getters['suppliers/detailForm']
    },
  },
  methods: {
    detailToggle() {
      this.$store.commit('suppliers/SET_DETAIL_FORM', !this.detailForm)
    },
  },
}
</script>
